import React from 'react';
import PhoneIcon from './PhoneIcon';
import PhoneText from './PhoneText';

const PhoneCall: React.FC<{
	text?: string;
	phoneNumber?: string;
	position: string;
	iconClassName?: string;
	textClassName?: string;
	shortText?: string;
}> = ({
	text,
	phoneNumber,
	position,
	iconClassName,
	textClassName,
	shortText,
}) => {
	return (
		<div className="text-brand text-sm font-semibold no-underline gap-2">
			<div className="flex gap-1 items-center">
				<PhoneIcon
					phoneNumber={phoneNumber}
					position={position}
					className={iconClassName}
				/>
				<PhoneText
					phoneNumber={phoneNumber}
					position={position}
					text={text}
					className={textClassName}
					shortText={shortText}
				/>
			</div>
		</div>
	);
};

export default PhoneCall;
